import React, { PureComponent } from 'react';
import { createPortal } from 'react-dom';

export default class Portal extends PureComponent {
    componentDidMount() {
        if (this.props.visible) {
            this._renderPortal(this.props);
            this.forceUpdate();
        }
    }

    componentWillReceiveProps(nextProps) {
        const { visible, onOpen } = nextProps;
        if (this.props.visible === visible) {
            return;
        }

        if (visible) {
            if (onOpen) {
                onOpen();
            }

            this._renderPortal(nextProps);
        } else {
            this._removePortal();
        }
    }

    componentWillUnmount() {
        if (this.props.visible && this.props.onClose) {
            this.props.onClose();
        }
        this._removePortal();
    }

    _container = null;
    _portal = null;

    _applyStyles = (props) => {
        if (props.className) {
            this._container.className = props.className;
        }
    };

    _renderPortal = (props) => {
        if (!this._container) {
            this._container = document.createElement(props.component);

            this._applyStyles(props);
            const node = (props.renderNode || document.body);
            if (props.lastChild) {
                node.appendChild(this._container);
            } else {
                node.insertBefore(this._container, node.firstChild);
            }
        } else {
            this._applyStyles(props);
        }
    };

    _removePortal = () => {
        if (this.props.onClose) {
            this.props.onClose();
        }

        if (this._container) {
             (this.props.renderNode || document.body).removeChild(this._container);
        }

        this._portal = null;
        this._container = null;
    };

    render() {
        const { component: Component, className, children, visible } = this.props;

        // When doing server side rendering, actually render the component as a direct child of its parent.
        // Once it has been rendered and working client side, it will be removed correctly.
        if (typeof window === 'undefined' && visible) {
            return <Component className={className}>{children}</Component>;
        } else if (visible && this._container && typeof window !== 'undefined') {
            return createPortal(children, this._container);
        }

        return null;
    }
}
